export const CALENDLY_URL = "https://calendly.com/finable/kennenlerngespraech";
export const APP_STORE_URL = "https://apps.apple.com/app/id6648793330";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=de.demv.finanzmanager.app&hl=de";
export const WEB_LOGIN_URL = "https://meine-finanzen.digital/login?redirect=%252Fmeine-vertraege";
export const STAFF_LOGIN_URL = "https://mvp.professional.works";
